var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgValidationSuccess = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75781 10.7539L0.191406 6.21484C0.0638021 6.08724 0 5.92318 0 5.72266C0 5.52214 0.0638021 5.35807 0.191406 5.23047L1.20312 4.24609C1.33073 4.10026 1.48568 4.02734 1.66797 4.02734C1.86849 4.02734 2.04167 4.10026 2.1875 4.24609L5.25 7.30859L11.8125 0.746094C11.9583 0.60026 12.1224 0.527344 12.3047 0.527344C12.5052 0.527344 12.6693 0.60026 12.7969 0.746094L13.8086 1.73047C13.9362 1.85807 14 2.02214 14 2.22266C14 2.42318 13.9362 2.58724 13.8086 2.71484L5.74219 10.7539C5.61458 10.8997 5.45052 10.9727 5.25 10.9727C5.04948 10.9727 4.88542 10.8997 4.75781 10.7539Z",
    fill: "#008D17"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgValidationSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/validationSuccess.7fb06569.svg";
export { ForwardRef as ReactComponent };